/* src/app/modules/concept/concept-statistics/concept-statistics.component.css */
:host {
  --cs-brand: #e3fd64;
  --cs-brand-d: #4d7a00;
  --cs-red: #c8002d;
  --cs-text: #1a1d23;
  --cs-muted: #6b7280;
  --cs-border: #e5e7eb;
  --cs-bg: #f4f6f8;
  --cs-surface: #ffffff;
  --cs-radius: 10px;
  --cs-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.cs-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cs-bg);
  font-family: "Inter Tight", sans-serif;
}
.cs-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cs-surface);
  border-bottom: 1px solid var(--cs-border);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.cs-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cs-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cs-brand-d);
}
.cs-header__text {
  flex: 1;
  min-width: 0;
}
.cs-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cs-text);
  line-height: 1.3;
}
.cs-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cs-muted);
}
.cs-header__filter {
  margin-left: auto;
  flex-shrink: 0;
}
.cs-months-field {
  min-width: 220px;
}
.cs-body {
  padding: 20px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media (max-width: 768px) {
  .cs-header {
    padding: 10px 14px;
  }
  .cs-body {
    padding: 12px;
  }
  .cs-header__filter {
    width: 100%;
  }
  .cs-months-field {
    width: 100%;
  }
}
.cs-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 64px 0;
}
.cs-loading__dots {
  display: flex;
  gap: 8px;
}
.cs-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--cs-brand);
  opacity: 0.3;
  animation: cs-pulse 1.2s ease-in-out infinite;
}
.cs-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.cs-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.cs-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--cs-muted);
}
@keyframes cs-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.cs-chart-card {
  background: var(--cs-surface);
  border: 1px solid var(--cs-border);
  border-radius: var(--cs-radius);
  box-shadow: var(--cs-shadow);
  overflow: hidden;
  height: 100%;
  transition: box-shadow 0.15s, transform 0.15s;
}
.cs-chart-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}
.cs-chart-card__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--cs-border);
  background: #fafafa;
}
.cs-chart-card__badge {
  width: 36px;
  height: 36px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.cs-chart-card__badge mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cs-chart-card__badge--amber {
  background: rgba(77, 122, 0, 0.12);
}
.cs-chart-card__badge--amber mat-icon {
  color: var(--cs-brand-d);
}
.cs-chart-card__badge--red {
  background: rgba(220, 38, 38, 0.08);
}
.cs-chart-card__badge--red mat-icon {
  color: var(--cf-error, #dc2626);
}
.cs-chart-card__badge--blue {
  background: rgba(42, 120, 214, 0.1);
}
.cs-chart-card__badge--blue mat-icon {
  color: #2a78d6;
}
.cs-chart-card__title {
  margin: 0 0 2px;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--cs-text);
}
.cs-chart-card__sub {
  margin: 0;
  font-size: 11.5px;
  color: var(--cs-muted);
}
.cs-chart-card__body {
  padding: 18px;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.cs-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 32px 16px;
  color: var(--cs-muted);
  text-align: center;
}
.cs-empty mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  opacity: 0.3;
}
.cs-empty p {
  margin: 0;
  font-size: 13px;
}
::ng-deep .cs-header .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .cs-header .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
/*# sourceMappingURL=concept-statistics.component.css.map */
